<template>
  <component
    :is="rootElement"
    :class="userClasses"
    v-bind="rootAttributes"
    data-cy="ds-user"
    @click="handleClick"
  >
    <DSUserAvatar
      v-if="props.showAvatar"
      v-bind="avatarProps"
    />

    <span
      v-if="props.name || props.statusText"
      :class="DS_USER_CLASSES.Details"
      data-cy="ds-user__details"
    >
      <span
        v-if="props.name"
        :class="DS_USER_CLASSES.Name"
        data-cy="ds-user__name"
      >
        {{ props.name }}
      </span>
      <span
        v-if="props.statusText"
        :class="statusClasses"
        data-cy="ds-user__status"
      >
        {{ props.statusText }}
      </span>
    </span>
  </component>
</template>

<script setup lang="ts">
import DSUserAvatar from "@/src/design_system/data_display/user/components/DSUserAvatar.vue";
import { DS_USER_CLASSES } from "@/src/design_system/data_display/user/constants/classes";
import { useDSUser } from "@/src/design_system/data_display/user/composables/useDSUser";
import { DSUserEmits } from "@/src/design_system/data_display/user/types/emits";
import { DSUserProps } from "@/src/design_system/data_display/user/types/props";
import { DS_USER_SIZE } from "@/src/design_system/data_display/user/types/size";
import { DS_USER_STATUS } from "@/src/design_system/data_display/user/types/status";

const props = withDefaults(defineProps<DSUserProps>(), {
  name: undefined,
  statusText: undefined,
  href: undefined,
  hasAction: true,
  showAvatar: true,
  size: DS_USER_SIZE.Large,
  avatarStatus: DS_USER_STATUS.None,
  avatarSrc: undefined,
  avatarAlt: undefined,
  avatarText: undefined,
  avatarIconName: "user",
  ariaLabel: undefined,
});

const emit = defineEmits<DSUserEmits>();

const { avatarProps, handleClick, rootAttributes, rootElement, statusClasses, userClasses } = useDSUser(props, emit);
</script>
